var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"clamp",staticClass:"clamp",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('div',{ref:"realText",attrs:{"title":_vm.clamped ? _vm.text : null}}),_c('div',{ref:"slotContainer",attrs:{"hidden":""}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }